var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpanishFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flags-2",
    clipPath: "url(#clip0_3427_18909)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V10C0.5 11.1046 1.39543 12 2.5 12H10.5C11.6046 12 12.5 11.1046 12.5 10V2C12.5 0.89543 11.6046 0 10.5 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3427_18909",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V10C0.5 11.1046 1.39543 12 2.5 12H10.5C11.6046 12 12.5 11.1046 12.5 10V2C12.5 0.89543 11.6046 0 10.5 0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3427_18909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.2H12.5V0H0.5V3.2Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 11.9998H12.5V8.7998H0.5V11.9998Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 8.79971H12.5V3.19971H0.5V8.79971Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64258 5.6001H4.21401V6.0001H3.64258V5.6001Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.51129 4C3.26828 4 3.07129 4.28653 3.07129 4.64C3.07129 4.72836 3.12054 4.8 3.18129 4.8H4.10414C4.1649 4.8 4.21414 4.72836 4.21414 4.64C4.21414 4.28653 4.01715 4 3.77414 4H3.51129Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.46387 4.80029C2.3258 4.80029 2.21387 4.9631 2.21387 5.16393V7.23666C2.21387 7.43749 2.3258 7.60029 2.46387 7.60029H2.5353C2.67337 7.60029 2.7853 7.43749 2.7853 7.23666V5.16393C2.7853 4.9631 2.67337 4.80029 2.5353 4.80029H2.46387Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20068 5.2002C3.05411 5.2002 2.93898 5.38279 2.95163 5.5952L3.03141 6.93566C3.05379 7.3116 3.27012 7.6002 3.52953 7.6002H3.7552C4.01461 7.6002 4.23093 7.3116 4.25331 6.93566L4.3331 5.5952C4.34575 5.38278 4.23061 5.2002 4.08404 5.2002H3.20068ZM4.08404 5.56383H3.20068L3.22666 6.00027H4.05806L4.08404 5.56383ZM3.28046 6.90429L3.25047 6.40027H3.35669L3.64242 7.20027L3.92812 6.40027H4.03426L4.00427 6.90429C3.99308 7.09226 3.88491 7.23656 3.7552 7.23656H3.52953C3.39982 7.23656 3.29165 7.09226 3.28046 6.90429Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.5 5.16393C4.5 4.9631 4.61192 4.80029 4.75 4.80029H4.82142C4.9595 4.80029 5.07142 4.9631 5.07142 5.16393V7.23666C5.07142 7.43749 4.9595 7.60029 4.82142 7.60029H4.75C4.61192 7.60029 4.5 7.43749 4.5 7.23666V5.16393Z",
    fill: "#A41517"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_18909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpanishFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SpanishFlag.15f5e08babaa6156564b765b72a4480b.svg";